/**
 * PANDA Guide Collections.
 * Breathing, hover scale and the fade/slide reveal are pure CSS.
 *
 * JS responsibilities:
 * 1. Fit the background word so it spans the section width at any screen
 *    size and for any word/font choice (CSS cannot measure rendered text).
 * 2. Drive a light mouse-parallax on the panda image (fine-pointer devices
 *    only, skipped under reduced-motion or when disabled in settings).
 * 3. Trigger the fade-up reveal once the section scrolls into view.
 * 4. A small ripple effect on click for the age-group circles.
 */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasFinePointer = window.matchMedia('(pointer: fine)').matches;

  function fitWord(section) {
    var word = section.querySelector('[data-pgc-word]');
    if (!word) return;

    var naturalWidth = word.scrollWidth;
    if (!naturalWidth) return;

    var margin = window.innerWidth <= 749 ? 0.92 : 0.96;
    var availableWidth = section.clientWidth * margin;

    word.style.setProperty('--pgc-word-fit-scale', availableWidth / naturalWidth);
  }

  function initParallax(section) {
    if (reducedMotion || !hasFinePointer || section.dataset.parallax === 'false') return;

    var stage = section.querySelector('[data-pgc-panda-stage]');
    var target = section.querySelector('[data-pgc-panda-parallax]');
    if (!stage || !target) return;

    var ticking = false;
    var pointerX = 0;
    var pointerY = 0;

    function apply() {
      target.style.setProperty('--pgc-parallax-x', pointerX + 'px');
      target.style.setProperty('--pgc-parallax-y', pointerY + 'px');
      ticking = false;
    }

    stage.addEventListener('mousemove', function (e) {
      var rect = stage.getBoundingClientRect();
      var relX = (e.clientX - rect.left) / rect.width - 0.5;
      var relY = (e.clientY - rect.top) / rect.height - 0.5;
      pointerX = relX * 18;
      pointerY = relY * 18;

      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(apply);
      }
    });

    stage.addEventListener('mouseleave', function () {
      pointerX = 0;
      pointerY = 0;
      window.requestAnimationFrame(apply);
    });
  }

  function initRipple(section) {
    if (reducedMotion) return;

    section.querySelectorAll('[data-pgc-badge]').forEach(function (badge) {
      var circle = badge.querySelector('.pgc-badge__circle');
      if (!circle) return;

      badge.addEventListener('click', function (e) {
        var rect = circle.getBoundingClientRect();
        var size = Math.max(rect.width, rect.height);
        var ripple = document.createElement('span');
        ripple.className = 'pgc-ripple';
        ripple.style.width = size + 'px';
        ripple.style.height = size + 'px';
        ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
        ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';
        circle.appendChild(ripple);

        var cleanup = function () {
          if (ripple.parentNode) ripple.parentNode.removeChild(ripple);
        };
        ripple.addEventListener('animationend', cleanup);
        setTimeout(cleanup, 800);
      });
    });
  }

  function reveal(section) {
    section.querySelectorAll('[data-pgc-reveal]').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pgc-section]').forEach(function (section) {
      if (section._pgcInit) return;
      section._pgcInit = true;

      fitWord(section);
      initParallax(section);
      initRipple(section);

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { fitWord(section); });
      }

      var resizeTimer;
      var onResize = function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { fitWord(section); }, 120);
      };

      if ('ResizeObserver' in window) {
        new ResizeObserver(onResize).observe(section);
      } else {
        window.addEventListener('resize', onResize);
      }

      if (section.dataset.animate === 'false' || !('IntersectionObserver' in window)) {
        reveal(section);
        return;
      }

      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(section);
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

      revealObserver.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();